import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Ranking from "./components/Ranking";
import Spotlight from "./components/Spotlight";
import Collections from "./components/Collections";
import FlashFeed from "./components/FlashFeed";
import Roundups from "./components/Roundups";
import Recommended from "./components/Recommended";
import Subscribe from "./components/Subscribe";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <Ranking />
        <Spotlight />
        <Collections />
        <FlashFeed />
        <Roundups />
        <Recommended />
        <Subscribe />
      </main>
      <Footer />
    </div>
  );
}